import { GetTranslationFunc } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { TFunction } from 'i18next';
import { OnboardingData, OnboardingStep } from '../../types/onboarding';

// Step validation rules
const validateStep = (
  step: OnboardingStep,
  data: OnboardingData,
  t: TFunction<'translation', undefined>,
  t2: GetTranslationFunc,
): { isValid: boolean; error?: string } => {
  const limit = 3;

  switch (step) {
    case 'welcome':
      return { isValid: true };

    case 'company-info-1':
      if (!data.formData.legal_structure?.length) {
        return {
          isValid: false,
          error: t2('onboardingClient|legal_structure_required'),
        };
      }
      if (!data.formData.company_name) {
        return {
          isValid: false,
          error: t('onboarding.validation.company_name_required'),
        };
      }
      if (!data.formData.city) {
        return {
          isValid: false,
          error: t2('onboardingClient|city_required'),
        };
      }
      return { isValid: true };

    case 'company-details':
      if (!data.formData.industry_sector?.length) {
        return {
          isValid: false,
          error: t2('onboardingClient|industry_sector_required'),
        };
      }
      if ((data.formData.industry_sector?.length ?? 0) > limit) {
        return {
          isValid: false,
          error: t('onboarding.validation.industry_sector_max_3'),
        };
      }
      if (!data.formData.annual_revenue) {
        return {
          isValid: false,
          error: t('profile|profileForm.company.validation.annualRevenue'),
        };
      }
      if (!data.formData.company_size) {
        return {
          isValid: false,
          error: t2('onboardingClient|company_size_required'),
        };
      }
      return { isValid: true };

    case 'company-details-npo':
      if (!data.formData.industries_icnpo?.length) {
        return {
          isValid: false,
          error: t2('onboardingClient|industries_icnpo_required'),
        };
      }
      if ((data.formData.industries_icnpo?.length ?? 0) > limit) {
        return {
          isValid: false,
          error: t2('onboardingClient|industries_icnpo_max_limit', { limit }),
        };
      }
      if (!data.formData.npo_stream_id) {
        return {
          isValid: false,
          error: t2('onboardingClient|npo_streams_required'),
        };
      }
      if (!data.formData.npo_beneficiaries?.length) {
        return {
          isValid: false,
          error: t2('onboardingClient|npo_beneficiaries_required'),
        };
      }
      if ((data.formData.npo_beneficiaries?.length ?? 0) > limit) {
        return {
          isValid: false,
          error: t2('onboardingClient|npo_beneficiaries_max_limit', { limit }),
        };
      }
      return { isValid: true };

    default:
      return { isValid: true };
  }
};

export default validateStep;
